import slugify from 'slugify'
import { db, serverTimestamp, FieldValue } from '@/main.js'

export default {
  props: ['profile', 'site'],
  data() {
    return {
      is_creating: false
    }
  },
  methods: {
    go_to_entry(entry, is_new, force, evt) {
      console.log('entry', evt)
      if (force === 'settings') {
        evt.stopPropagation()
        this.$router.push({name: 'entry_page_settings', params: {id: entry.id}})
        return false
      }

      if (is_new) {
        if (entry.types.indexOf('block') > -1) {
          this.$router.push({name: 'entry_page_settings', params: {id: entry.id}})
        } else {
          this.$router.push({name: 'entry_page', params: {id: entry.id}})
        }
      } else {
        if (entry.types.indexOf('page') > -1) {
          this.$router.push({name: 'entry_page', params: {id: entry.id}})
        } else {
          this.$router.push({name: 'entry_page_settings', params: {id: entry.id}})
        }
      }
    },
    async entry_create(collection) {
      let result = await this.$swal({
        title: 'Entry name',
        input: 'text',
        showCancelButton: true,
      })

      if (!result || !result.value) {
        return
      }

      let block = null
      let page = null

      if (collection.types.indexOf('block') > -1) {
        block = {
          content: {}
        }

        if (collection.name === 'forms') {
          block.content.fields = []
        }
      }

      if (collection.types.indexOf('page') > -1) {
        let hero_id = db.collection('random').doc().id
        if (collection.template && collection.template.page && collection.template.page.blocks) {
          hero_id = collection.template.page.blocks[0].id
        }

        let blocks_content = {}
        blocks_content[hero_id] = {header: result.value, sub_heading: 'Sub heading', id: hero_id}
        page = {
          title: result.value,
          slug: slugify(result.value.toLowerCase()),
          blocks: [{type: 'hero', id: hero_id}],
          blocks_content: blocks_content,
          template: null
        }

        if (collection.template) {
          page.blocks = null
          page.template = db.collection('site').doc(this.$route.params.site_id).collection('entry').doc(collection.template.id)
        }
      }

      let item = {
        created: new Date(),
        updated: new Date(),
        name: result.value,
        template: false,
        types: collection.types,
        collection: collection.name,
        block: block,
        page: page,
        status: 'published',
        user: this.profile.id
      }

      this.is_creating = true
      let item_doc = db.collection('site').doc(this.$route.params.site_id).collection('entry').doc()
      item.id = item_doc.id
      await item_doc.set(item)
      let update = {}
      update[`collections.${collection.name}.entries`] = FieldValue.arrayUnion(item_doc)
      await db.collection('site').doc(this.$route.params.site_id).update(update)
      await db.collection('deploy_queue').doc(this.site.id).set({updated: serverTimestamp(), update_count: FieldValue.increment(1)}, {merge: true})
      this.is_creating = false

      item.id = item_doc.id

      this.go_to_entry(item, true)
    }
  }
}
